export const GET_SATCONTENT = 'getSatContent';
export const GET_SATCONTENTACTION = 'getSatContentAction';
export const GET_SATSAVEDDATA = 'getSatSavedData';
export const GET_SATSAVEDDATAACTION = 'getSatSavedDataAction';
export const GET_NOTIFICATIONS = 'getNotifications';
export const GET_NOTIFICATIONSACTION = 'getNotificationsAction';
export const SAVE_NOTIFICATION = 'saveNotification';
export const SAVE_NOTIFICATIONACTION = 'saveNotificationAction';
export const CREATE_USER = 'createUser';
export const UPDATE_USER = 'updateUser';
export const SET_USER = 'setUser';
export const RESET_USER_STATE ='resetUser';
export const DELETE_USER = 'deleteUser';
export const GET_ROLES = 'getRoles';
export const GET_REFERRALS = 'getReferrals';
export const GET_FOOTER= 'getFooter';
export const SIGNIN = 'signin';
export const SIGNOUT = 'signout';
export const RESETPASSWORD = 'resetPassword';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const CLEAR = 'clear';
export const SET_EMAIL="setEmail";
export const GET_CONTENT = 'getContent';



